import React from "react";
import { Box, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ServerErrorPage = () => {

  const onRetry = () => {
    window.location.reload();
  };
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 80, color: "#d32f2f" }} />

      <Typography variant="h4" mt={2} fontWeight="bold">
        500 - Server Error
      </Typography>

      <Typography variant="body1" mt={1} color="text.secondary">
        Something went wrong on our end. Please try again later.
      </Typography>

      <Button
        variant="contained"
        color="error"
        sx={{ mt: 3, px: 4 }}
        onClick={onRetry}
      >
        Retry
      </Button>
    </Box>
  );
};

export default ServerErrorPage;